module.exports = __webpack_public_path__ + "static/media/img-12.png";